'use strict';

/**
 *
 * @name: previewsConfig
 *
 */

function PreviewsConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('PreviewsBundle');
  }

  $stateProvider
    .state('main.previews', {
      url: 'previews',
      controller: 'PreviewsController',
      templateProvider: $templateCache => $templateCache.get('previews.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers,
        modules: function($q, apiModulesService, $location) {

          var deferred = $q.defer();

          if ($location.search().parentType) {

            var parentType = $location.search().parentType;
            var parentSlug = $location.search().parentSlug || false;

            apiModulesService
              .getModules(parentType, parentSlug)
              .then(function(result) {

                deferred.resolve(result.data);
              }, function() {

                deferred.reject('module load err');
              });

          } else {

            deferred.resolve({});
          }

          return deferred.promise;
        }
      }
    })
    .state('main.mosaicPreview', {
      url: 'mosaic-preview',
      controller: 'MosaicPreviewController',
      resolve: {
        moduleControllers: _resolveModuleControllers,
      },
      templateProvider: $templateCache => $templateCache.get('mosaic-preview.index.html')
    })
    .state('main.notificationPreview', {
      url: 'notification-preview',
      controller: 'NotificationPreviewController as NPC',
      resolve: {
        moduleControllers: _resolveModuleControllers,
      },
      templateProvider: $templateCache => $templateCache.get('notification-preview.index.html')
    });
}

export default PreviewsConfig;



// WEBPACK FOOTER //
// ./app/pages/previews/previews.config.js